export enum AlignTypeEnum {
  LEFT = 1,
  CENTER = 2,
  RIGHT = 3
}
